import React from 'react';
import runningOffer1 from '../../../Assert/RunningOffer1.png'

const RunningOffer = () => {
    return (
        <>
            <div className=" bg-gray-100 grid lg:grid-cols-2 md:grid-cols-2 grid-cols-1  gap-2 lg:py-12 py-10">
                <div className="mx-4"><img src={runningOffer1} alt="" /></div>
                <div className="mx-4"><img src={runningOffer1} alt="" /></div>
            </div>
            
        </>
    );
};

export default RunningOffer;